<template>
    <b-modal
        :title="$t('history.modal.header.ChangeReference')"
        ref="info-modal"
        @ok="updateReferences"
    >
        <form ref="form">
            <b-form-group :label="$t('history.modal.body.SendersReference')">
                <b-form-input
                    v-model="sendersReference"
                    required
                    name="sendersReferenceModalInput"
                ></b-form-input>
            </b-form-group>

            <b-form-group :label="$t('history.modal.body.ReceiversReference')">
                <b-form-input
                    v-model="receiversReference"
                    required
                    name="receiversReferenceModalInput"
                ></b-form-input>
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" name="changeReferenceModalButton" variant="primary">
                {{ $t('history.modal.button.Change') }}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
import helpers from '@/helper';

export default {
    props: {
        shipment: { type: Object, required: true }
    },

    data() {
        return {
            sendersReference: null,
            receiversReference: null
        };
    },

    methods: {
        showReferenceModal() {
            const cloneShipment = helpers.cloneObject(this.shipment);
            this.sendersReference = cloneShipment.sendersReference;
            this.receiversReference = cloneShipment.receiversReference;

            this.$refs['info-modal'].show();
        },

        updateReferences() {
            this.shipment.sendersReference = this.sendersReference;
            this.shipment.receiversReference = this.receiversReference;

            this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_SENDER_RECEIVER_REFERENCE,
                this.shipment
            );
        }
    }
};
</script>

<style></style>
